import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import axios, { BASE_URL } from "../axiosConfig";

import "./CampanhaInscricao.css";

const getImagemUrl = (img) => {
  if (!img) return "";

  // Se começar com http://localhost:xxxx, substitui pela BASE_URL
  if (img.startsWith("http://localhost:3001")) {
    return img.replace("http://localhost:3001", BASE_URL);
  }

  // Para qualquer http://localhost:<porta>
  if (/^http:\/\/localhost:\d+/.test(img)) {
    return img.replace(/^http:\/\/localhost:\d+/, BASE_URL);
  }

  // Se for caminho relativo
  return img.startsWith("http") ? img : `${BASE_URL}${img}`;
};

function CampanhaInscricao() {
  const { id } = useParams();
  const navigate = useNavigate();
  const usuario = JSON.parse(localStorage.getItem("usuario"));

  const [campanha, setCampanha] = useState(null);
  const [jaInscrito, setJaInscrito] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [dataInscricao, setDataInscricao] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    async function carregarDados() {
      try {
        const campanhasRes = await axios.get("/campanhas");
        const encontrada = campanhasRes.data.find(c => c.id === parseInt(id));
        setCampanha(encontrada);

        const inscritosRes = await axios.get(`/campanhas/${id}/inscritos`);
        const inscrito = inscritosRes.data.find(i => i.email === usuario.email);
        if (inscrito) {
          setJaInscrito(true);
          setDataInscricao(inscrito.data_inscricao);
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        setCarregando(false);
      }
    }
    carregarDados();
  }, [id, usuario.email]);

  const inscrever = () => {
    axios.post(`/campanhas/${id}/inscrever`, {
      cliente_id: usuario.id,
    })
      .then(() => {
        setMensagem("Inscrição realizada com sucesso!");
        setJaInscrito(true);
        setDataInscricao(new Date().toISOString());
      })
      .catch(err => {
        setMensagem("Erro ao inscrever: " + err.response.data.error);
      });
  };

  const cancelarInscricao = () => {
    axios.delete(`/campanhas/${id}/cancelar/${usuario.id}`)
      .then(() => {
        setMensagem("Inscrição cancelada.");
        setJaInscrito(false);
        setDataInscricao(null);
      })
      .catch(err => {
        setMensagem("Erro ao cancelar inscrição: " + err.response.data.error);
      });
  };

  const confirmarCancelamento = () => {
    const confirmar = window.confirm("Tem certeza que deseja cancelar sua inscrição nesta campanha?");
    if (confirmar) {
      cancelarInscricao(); // chama sua função normal de cancelamento
    }
  };

  if (carregando) return <p>Carregando campanha...</p>;
  if (!campanha) return <p>Campanha não encontrada.</p>;

  return (
    <div className="campanha-inscricao-container fade-in">
      <h2>🎯 {campanha.titulo}</h2>
      <img
  src={getImagemUrl(campanha.imagem)}
  alt={campanha.titulo}
  className="campanha-inscricao-img"
/>



      <p>📝 {campanha.descricao}</p>
      <p><strong>📅 Período:</strong> {new Date(campanha.data_inicio).toLocaleDateString("pt-BR")} a {new Date(campanha.data_fim).toLocaleDateString("pt-BR")}</p>
      <p><strong>🏆 Recompensa:</strong> {campanha.recompensa}</p>
      <p><strong>⭐ Objetivo:</strong> {campanha.pontos_objetivo.toLocaleString("pt-BR")} pontos</p>

      {jaInscrito && dataInscricao && (
        <p className="info-inscrito">
          ✅ Você está inscrito desde {new Date(dataInscricao).toLocaleString("pt-BR")}
        </p>
      )}

      {mensagem && <div className="mensagem-inscricao">{mensagem}</div>}

      {!jaInscrito ? (
        <button className="btn-inscrever" onClick={inscrever}>Inscrever-se</button>
      ) : (
        <button onClick={confirmarCancelamento}>Cancelar inscrição</button>
      )}

      <div style={{ marginTop: "20px" }}>
        <button onClick={() => navigate("/painel-cliente")} className="btn-voltar">
          Voltar ao painel
        </button>
      </div>
    </div>
  );
}

export default CampanhaInscricao;
